import { Component } from '@angular/core';

@Component({
  selector: 'app-whycyclops',
  templateUrl: './whycyclops.component.html',
  styleUrls: ['./whycyclops.component.scss'] // fix typo: `styleUrl` → `styleUrls`
})
export class WhycyclopsComponent {}

